import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22.722 2.692a1 1 0 1 0-1.444-1.384L17.21 5.554l-1.489-1.553a1 1 0 1 0-1.444 1.383l2.21 2.308a1 1 0 0 0 1.445 0zm-.696 19.447a3 3 0 0 0 .972-2.223v-2.985a3 3 0 0 0-2.58-3.031 12 12 0 0 1-2.6-.647 3 3 0 0 0-3.163.676l-.721.721a15 15 0 0 1-4.586-4.586l.717-.717a3 3 0 0 0 .68-3.169A11.8 11.8 0 0 1 10.1 3.59 3 3 0 0 0 7.098 1h-2.99a3 3 0 0 0-2.986 3.27 20.8 20.8 0 0 0 3.227 9.124 20.5 20.5 0 0 0 6.303 6.3 20.8 20.8 0 0 0 9.058 3.22 3 3 0 0 0 2.316-.775m-1.028-5.244v3.025a1 1 0 0 1-1.09 1.004 18.8 18.8 0 0 1-8.176-2.913 18.5 18.5 0 0 1-5.7-5.697 18.8 18.8 0 0 1-2.92-8.24A1 1 0 0 1 4.11 3h3c.51-.005.939.363 1.009.86.135 1.026.388 2.042.753 3.02a1 1 0 0 1-.224 1.057L7.381 9.203a1 1 0 0 0-.162 1.201 17 17 0 0 0 6.375 6.375 1 1 0 0 0 1.201-.162l1.27-1.27a1 1 0 0 1 1.051-.22c.98.365 1.997.618 3.031.755.494.07.864.506.851 1.013",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }